import { combineReducers } from '@reduxjs/toolkit';
import checkoutSaga from '@state/features/checkout.saga';
import checkoutSlice from '@state/features/checkout.slice';
import { all, fork } from 'redux-saga/effects';
export const checkoutRootReducer = combineReducers({
    checkout: checkoutSlice.reducer,
});
export function* checkoutRootSaga() {
    yield all([fork(checkoutSaga)]);
}
